import Inject from './Inject.component';
export type { InjectedComponentType, InjectConfig, GetComponentType } from './Inject.component';
export default Inject;
